import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Cropper from 'react-cropper';
import isEmpty from 'lodash/isEmpty';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Colors from '../styles/colors';

function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
  else byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

class ImageCropModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: '',
      cropResult: null,
      cropped: false,
      width: 16,
      height: 9,
      crop: {
        x: 20,
        y: 10,
        aspect: 1 / 1,
        height: 10,
      },
    };

    this.cropperRef = null;
    this.cropImage = this.cropImage.bind(this);
    this.cancelCrop = this.cancelCrop.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.saveImage = this.saveImage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let file = nextProps.file;
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var image = new Image();
        image.src = reader.result;

        image.onload = () => {
          this.setState({
            src: reader.result,
            height: image.height,
            width: image.width,
          });
        };
      };
    }
  }

  cancelCrop() {
    this.setState({
      cropped: false,
      cropResult: null,
    });
  }

  cropImage() {
    const { type = '' } = this.props.file;
    if (isEmpty(type)) {
      alert('Invalid image type');
      return this.cancelCrop();
    }

    const cropResult = this.cropperRef.getCroppedCanvas().toDataURL(type);
    this.setState({
      cropResult,
      cropped: true,
    });
  }

  closeModal() {
    this.setState({
      cropped: false,
      cropResult: null,
    }, this.props.handleClose);
  }

  saveImage() {
    const { cropResult } = this.state;
    if (cropResult) {
      this.setState({
        cropResult: null,
        cropped: false,
      }, () => {
        const fileBlob = dataURItoBlob(cropResult);
        this.props.upload && this.props.upload(fileBlob, this.props.imageType);
        this.props.onCrop && this.props.onCrop(fileBlob, cropResult);
      });
    } else {
      return alert('Please confirm image crop before saving.');
    }
    // console.log('fileBlob: ', fileBlob);
  }

  renderCropWindow() {
    return (
      <CropWindow>
        <Cropper
          style={{ height: 350 }}
          src={this.state.src}
          viewMode={1}
          ref={ref => this.cropperRef = ref}
          aspectRatio={this.props.aspectRatio}
          guides={false}
          autoCropArea={1}
        />
        <div className="action-btn">
          <RaisedButton
            onClick={this.cropImage}
            backgroundColor={Colors.mainOrange}
            label="Confirm Crop"
            fullWidth={true}
            labelStyle={{
              color: '#fff'
            }}
          />
        </div>
      </CropWindow>
    );
  }

  renderCropResult() {
    return (
      <CropperResult>
        <div className="animated fadeIn">
          <img className="result-image" src={this.state.cropResult} alt="cropped image" />
        </div>
        <div className="action-btn">
          <RaisedButton onClick={this.cancelCrop} label="Undo" fullWidth={true} />
        </div>
      </CropperResult>
    );
  }

  render() {
    return (
      <MuiThemeProvider>
        <Dialog
          title="Crop Image"
          actions={[
            <FlatButton label="Cancel" onClick={this.closeModal} />,
            <FlatButton label="Save" primary={true} onClick={this.saveImage} />
          ]}
          modal={false}
          open={this.props.open}
          onRequestClose={this.closeModal}
          contentStyle={{ width: '80%' }}
          bodyStyle={{ minHeight: 420 }}
        >
          {!this.state.cropped && this.renderCropWindow()}
          {this.state.cropped && this.renderCropResult()}
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

const CropWindow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  alignitems: center;

  .action-btn {
    width: 100%;
    padding: 1rem 0;
  }
`;

const CropperResult = styled.div`
  width: 100%;

  .animated {
    display: flex;
    justify-content: center;
    background: #f2f2f2;
    padding: 1.5rem;
    animation-duration: 200ms;
  }

  .result-image {
    height: 300px;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  }

  .action-btn {
    width: 100%;
    padding: 1rem 0;
  }
`;

ImageCropModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onCrop: PropTypes.func,
  upload: PropTypes.func,
  file: PropTypes.any,
  aspectRatio: PropTypes.number,
};

ImageCropModal.defaultProps = {
  open: false,
  handleClose: () => {},
  onCrop: () => {},
  upload: () => {},
  file: null,
  aspectRatio: 1 / 1,
};

export default ImageCropModal;
